import React from "react";

import { clsx } from "clsx";

export const StyledInput = (props: any) => (
  <input
    {...props}
    className={clsx(
      props.className,
      "w-full border-b bg-transparent py-micro text-body leading-input outline-none focus:outline-none",
      props.error ? "border-warning" : "border-grey",
    )}
  />
);
